const styles = (theme) => ({
  container: {
    padding: "20px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
  },
  intro: {
    display: "flex",
    flexDirection: "column",
    gap: 0.3,
  },
  introTitle: {
    fontWeight: "bold",
    fontSize: "16px",
  },
  introDescription: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
  },
  blocksContainer: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
    gap: 2,
  },
  loadingState: {
    display: "flex",
    justifyContent: "center",
    padding: "24px 0",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    padding: "24px 0",
  },
  emptyTitle: {
    fontWeight: 600,
  },
  emptyDescription: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
    mt: 0.5,
    pt: 2,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  footerHint: {
    fontSize: "0.8rem",
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  footerActions: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
});

export default styles;
